export const copyTextToClipboard = (text: string): Promise<void> => {
    return new Promise((resolve, reject): void => {
        const textArea = document.createElement('textarea');
        setClipboardElementStyle(textArea);

        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            document.execCommand('copy');
            resolve();
        } catch (err) {
            reject();
        }

        document.body.removeChild(textArea);
    });
};

const setClipboardElementStyle = (textArea: HTMLTextAreaElement): void => {
    textArea.style.background = 'transparent';
    textArea.style.border = 'none';
    textArea.style.boxShadow = 'none';
    textArea.style.outline = 'none';
    textArea.style.padding = '0';

    textArea.style.height = '2em';
    textArea.style.width = '2em';

    textArea.style.position = 'fixed';
    textArea.style.left = '0';
    textArea.style.top = '0';
};
